import React, { useEffect, useState } from "react";
import httpRequest from "src/helpers/httpRequest";
import qs from "qs";
import CustomerTableWrapper from "./CustomerTableWrapper";
import { IPaginated } from "src/types/paginated";
import { toast } from "react-toastify";
import moment from "moment";
import cartIcon from "src/assets/images/cart-icon-green.png";
import eyeIcon from "src/assets/images/eye-icon-green.png";
import { Link } from "react-router-dom";
import AddCartComponent from "./ProductsAndServicesComponents/AddCartComponent";

interface IObj {
    productId: string;
    productName: string;
    frequency: string;
    dosage: string;
    instruction: string;
    createdAt: string;
    prescriptionRequired: boolean;
};

const PrescribeItemLists: React.FC<{ productType: "pharmacy" | "diagnostic" | "homecare"; doctorId: string }> = ({
    productType, doctorId,
}) => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IObj[]>([]);
    const [queryParams, setQueryParams] = useState<{ page: number; limit: number; productType?: "pharmacy" | "diagnostic" | "homecare"; doctorId?: string; }>({
        page: 1,
        limit: 10,
    });
    const [paginated, setPaginated] = useState<IPaginated>({
        currentPage: 1,
        totalPages: 1,
    });

    const handlePageChange = (e: number) => {
        setQueryParams(prev => ({
            ...prev,
            page: e
        }));
    };

    const printUrl = (id: string): string => {
        switch (productType) {
            case "pharmacy":
                return `/customer/pharmacy-product-detail/${id}/view`;
            case "diagnostic":
                return `/customer/diagnostic-product-detail/test/${id}/view`;
            case "homecare":
                return `/doctor/homecareservices/${id}/view`;
            default:
                return "";
        };
    };

    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<{ documents: IObj[]; paginated: IPaginated }>({ path: `/appoiment/prescribe-access-all?${qs.stringify(queryParams)}` });
        if (res) {
            const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } = res;
            setPaginated(paginated);
            setData(documents);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        if (queryParams.doctorId && queryParams.productType)
            fetch();
    }, [queryParams]);

    useEffect(() => {
        setQueryParams(prev => ({ ...prev, productType, doctorId, page: 1 }));
        setData([]);
    }, [productType, doctorId]);
    return (
        <CustomerTableWrapper
            isLoading={isLoader}
            thead={["S.No", "Test Name", "Prescribe Date", "Action"]}
            page={paginated?.currentPage || 1}
            total={paginated?.totalPages || 0}
            columnWidth={"12% 26% 50% 12%"}
            onChange={handlePageChange}
        >
            {data.map((item: IObj, index: number) => (
                <ul key={index} className='font-size-16px tbody-light-table customer-table-wrapper-body-padding-non customer-table-wrapper-body tbody-light-table-customer font-Poppins-Regular grid' style={{ gridTemplateColumns: "12% 26% 50% 12%" }}>
                    <li className="action-last-colum-non">{(paginated?.currentPage - 1) * queryParams.limit + (index + 1)}</li>
                    <li>{item?.productName || ""}</li>
                    <li>{moment(item?.createdAt).format("DD-MM-YYYY")}</li>
                    <li className="flex items-center gap-2">
                        {(productType === "pharmacy" || productType === "diagnostic") ?
                            <AddCartComponent
                                productId={item.productId}
                                type={productType}
                                prescriptionRequired={item.prescriptionRequired || false}
                                quantity={1}
                                greenCartIcon={true}
                            />
                            :
                            <Link to={`/customer/service/${item.productId}/view`}>
                                <img src={cartIcon} alt="Cart" className="w-[20px]" />
                            </Link>
                        }
                        <Link to={printUrl(item?.productId)}>
                            <img src={eyeIcon} alt="View" className="w-[20px]" />
                        </Link>
                    </li>
                </ul>
            ))}
        </CustomerTableWrapper>
    );
};

export default PrescribeItemLists;